import { render, staticRenderFns } from "./doughnut-data-visualizer.vue?vue&type=template&id=92e3bfa4&scoped=true&"
import script from "./doughnut-data-visualizer.vue?vue&type=script&lang=js&"
export * from "./doughnut-data-visualizer.vue?vue&type=script&lang=js&"
import style0 from "./doughnut-data-visualizer.vue?vue&type=style&index=0&id=92e3bfa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e3bfa4",
  null
  
)

export default component.exports